import { Button } from "@mui/material";

export default function ActionBadge({
  children,
  startIcon,
  endIcon,
  sx,
  ...props
}) {
  const actionBadgeSx = (theme) => ({
    backgroundColor: theme.palette.custom.gray[100],
    border: "1px solid",
    borderColor: theme.palette.custom.gray[200],
    borderRadius: theme.shape.radii.pill,
    boxShadow: "none",
    color: theme.palette.custom.gray[700],
    fontSize: 12,
    fontWeight: 900,
    minHeight: 32,
    px: 1.5,
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: theme.palette.custom.gray[200],
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.custom.gray[100],
      color: theme.palette.custom.gray[400],
    },
  });

  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      endIcon={endIcon}
      sx={Array.isArray(sx) ? [actionBadgeSx, ...sx] : [actionBadgeSx, sx]}
      {...props}
    >
      {children}
    </Button>
  );
}
